import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import { useCallback } from "react";
export default function Addmachine() {
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state;
  const [errors, setErrors] = useState({
    phone: "",
    image: "",
  });

  const [machines, setMachines] = useState([]);
  const [viewData, setViewData] = useState(null);
  const [showForm, setShowForm] = useState(true);
  const [loading, setLoading] = useState(false);
  const [renewPopup, setRenewPopup] = useState(false);
  const [renewMachineId, setRenewMachineId] = useState("");
  const [paymentImage, setPaymentImage] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const [renewData, setRenewData] = useState({
    show_ads_days: "",
    ads_amount: "",
    payment_screenshot: null,
  });
  const [form, setForm] = useState({
    id: "",

    machine_name: "",
    voltage: "",
    NoOfHeads: "",
    NoOfNeedls: "",
    beamBody: "",
    Maxsewingspeed: "",
    usbport: "",
    motor: "",
    brand: "",
    model: "",
    condition: "",
    price: "",
    location: "",
    city: "",
    state: "",
    name: "",
    phone: "",
    description: "",
    image: [],
    beamBodyWidth: "",
    beamBodyHeight: "",

    // ✅ NEW FIELDS
    left_head_type: "",
    right_head_type: "",
    Comtype: "",
    machine_old: "",
    show_ads_days: "",
    ads_amount: "",
    machine_year: "",
    machine_month: "",
    payment_screenshot: null,
  });
  const [adsPlans, setAdsPlans] = useState([]);

  useEffect(() => {
    fetch(API.GET_ADS_PLANS)
      .then(async (res) => {
        const text = await res.text();

        try {
          const data = JSON.parse(text);

          if (data.status) {
            setAdsPlans(data.data);
          }
        } catch (err) {
          console.log("Invalid JSON:", text);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  const [oldImages, setOldImages] = useState([]);
  useEffect(() => {
    if (editData) {
      setShowForm(true); // ✅ ADD THIS

      setOldImages([]);
      setForm((prev) => ({ ...prev, image: [] }));
      const parts = (editData.beamBody || "")
        .toLowerCase()
        .split("x")
        .map((v) => v.trim());

      const w = parts[0] || "";
      const h = parts[1] || "";

      // ✅ Machine age split
      let year = "";
      let month = "";

      if (editData.machine_old) {
        const ageParts = editData.machine_old.split("/");

        if (ageParts[0]) {
          year = ageParts[0].replace("Years", "").trim();
        }

        if (ageParts[1]) {
          month = ageParts[1].replace("Months", "").trim();
        }
      }
      setForm({
        id: editData.id,
        user_id: editData.user_id,
        machine_name: editData.machine_name || "",
        voltage: editData.voltage || "",
        NoOfHeads: editData.NoOfHeads || "",
        NoOfNeedls: editData.NoOfNeedls || "",
        beamBody: editData.beamBody || "",
        Maxsewingspeed: editData.Maxsewingspeed || "",
        usbport: editData.usbport || "",
        motor: editData.motor || "",
        brand: editData.brand || "",
        model: editData.model || "",
        condition: editData.condition_status || "",
        price: editData.price || "",
        location: editData.location || "",
        name: editData.name || "",
        city: editData.city || "",
        state: editData.state || "",
        phone: editData.phone || "",
        description: editData.description || "",
        beamBodyWidth: w || "",
        beamBodyHeight: h || "",
        image: [],
        left_head_type: editData.left_head_type || "",
        right_head_type: editData.right_head_type || "",
        Comtype: editData.Comtype || "",
        show_ads_days: editData.show_ads_days || "",
        ads_amount: editData.ads_amount || "",
        payment_screenshot: null,
        machine_year: year,
        machine_month: month,
        beamBodyWidth: w || "",
        beamBodyHeight: h || "",
      });

      const imagesArray = (editData.image || "")
        .split(",")
        .map((img) => img.trim())
        .filter((img) => img.length > 0);

      setOldImages(imagesArray);
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (
      form.id &&
      (name === "show_ads_days" || name === "payment_screenshot")
    ) {
      return; // Don't allow changes to ads fields when editing
    }
    // 📱 Phone validation
    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) return;

      if (value.length < 10) {
        setErrors((prev) => ({
          ...prev,
          phone: "Phone must be 10 digits",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          phone: "",
        }));
      }

      setForm({ ...form, [name]: value });
      return;
    }
    if (name === "beamBodyWidth" || name === "beamBodyHeight") {
      const updated = {
        ...form,
        [name]: value,
      };

      const width = name === "beamBodyWidth" ? value : form.beamBodyWidth;

      const height = name === "beamBodyHeight" ? value : form.beamBodyHeight;

      updated.beamBody = width && height ? `${width} x ${height}` : "";

      setForm(updated);
      return;
    }
    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find(
        (p) => String(p.days) === String(value),
      );

      setForm({
        ...form,
        show_ads_days: value,
        ads_amount: selectedPlan ? selectedPlan.amount : 0,
      });

      return;
    }
    // Machine Age Combine
    if (name === "machine_year" || name === "machine_month") {
      const updated = {
        ...form,
        [name]: value,
      };

      const years = updated.machine_year ? `${updated.machine_year} Years` : "";

      const months = updated.machine_month
        ? `${updated.machine_month} Months`
        : "";

      updated.machine_old =
        years && months ? `${years} / ${months}` : years || months || "";

      setForm(updated);
      return;
    }
    if (name === "payment_screenshot") {
      setForm({
        ...form,
        payment_screenshot: e.target.files[0],
      });
      return;
    }
    // 🖼 Image validation
    if (type === "file") {
      const files = Array.from(e.target.files);
      const totalImages = form.image.length + oldImages.length + files.length;

      if (totalImages > 6) {
        setErrors((prev) => ({
          ...prev,
          image: "Maximum 6 images allowed",
        }));
        return;
      }

      setForm({
        ...form,
        image: [...form.image, ...files],
      });

      setErrors((prev) => ({
        ...prev,
        image: "",
      }));

      return;
    }

    setForm({ ...form, [name]: value });
  };

  const removeNewImage = (index) => {
    const newImages = form.image.filter((_, i) => i !== index);
    setForm({ ...form, image: newImages });

    if (newImages.length + oldImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
    }
  };

  const removeOldImage = (index) => {
    const images = oldImages.filter((_, i) => i !== index);
    setOldImages(images);

    if (form.image.length + images.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ❗ Image required validation
    if (form.image.length + oldImages.length === 0) {
      setErrors((prev) => ({
        ...prev,
        image: "Minimum 1 image required",
      }));
      return;
    }

    // ❗ Stop if errors exist
    if (errors.phone || errors.image) {
      alert("Please fix validation errors");
      return;
    }

    if (loading) return;
    setLoading(true);

    const formData = new FormData();
    const user = JSON.parse(sessionStorage.getItem("user"));

    formData.append("user_id", user.id);

    // ✅ ALWAYS send show_ads_days (even if empty)
    formData.append("show_ads_days", form.show_ads_days || "");
    formData.append("ads_amount", form.ads_amount || "");

    Object.keys(form).forEach((key) => {
      if (
        key !== "image" &&
        key !== "payment_screenshot" &&
        key !== "show_ads_days" &&
        key !== "ads_amount"
      ) {
        formData.append(key, form[key]);
      }
    });

    if (form.payment_screenshot) {
      formData.append("payment_screenshot", form.payment_screenshot);
    }

    if (form.id) {
      formData.append("id", form.id);
      formData.append("oldImages", oldImages.join(","));
    }

    form.image.forEach((file) => {
      formData.append("image[]", file);
    });

    // Change these lines inside handleSubmit
    const url = form.id ? API.UPDATE_MACHINE : API.ADD_MACHINE;

    try {
      const res = await fetch(url, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === true) {
        alert(data.message);
        setShowForm(true);
        fetchMachines();
        setForm({
          id: "",
          machine_name: "",
          voltage: "",
          NoOfHeads: "",
          NoOfNeedls: "",
          beamBody: "",
          Maxsewingspeed: "",
          usbport: "",
          motor: "",
          brand: "",
          model: "",
          condition: "",
          price: "",
          location: "",
          city: "",
          state: "",
          name: "",
          phone: "",
          description: "",
          image: [],
          left_head_type: "",
          right_head_type: "",
          Comtype: "",
          show_ads_days: "",
          ads_amount: "",
          payment_screenshot: null,
          beamBodyWidth: "",
          beamBodyHeight: "",
          machine_old: "",
          machine_year: "",
          machine_month: "",
        });
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }

    setLoading(false);
  };

  const fetchMachines = async () => {
    try {
      const user = JSON.parse(sessionStorage.getItem("user"));

      const res = await fetch(
        `${API.LIST_MACHINES}&user_id=${user.id}&t=${Date.now()}`,
      );

      const text = await res.text();

      console.log("Machines RAW:", text);

      try {
        const data = JSON.parse(text);
        setMachines(Array.isArray(data) ? data : []);
      } catch (err) {
        console.log("Invalid JSON:", err);
        setMachines([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchMachines();
  }, []);

  const deleteMachine = async (id) => {
    if (!window.confirm("Delete machine?")) return;

    const res = await fetch(`${API.DELETE_MACHINE}&id=${id}`);
    const text = await res.text();

    console.log("Delete RAW:", text);

    let data;

    try {
      data = JSON.parse(text);
    } catch (err) {
      alert("Invalid server response");
      return;
    }
    fetchMachines();
  };
  const getTimeLeft = (expiryDate, status) => {
    // Don't show timer for PENDING machines
    if (status?.toLowerCase() === "pending") return null;

    if (!expiryDate) return null;

    const now = new Date().getTime();
    const expiry = new Date(expiryDate.replace(" ", "T")).getTime();
    const diff = expiry - now;

    if (diff <= 0) return "Expired";

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((diff / (1000 * 60)) % 60);

    return `${days}d ${hours}h ${mins}m`;
  };
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const handleRenewChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "show_ads_days") {
      const selectedPlan = adsPlans.find(
        (p) => String(p.days) === String(value),
      );

      setRenewData({
        ...renewData,
        show_ads_days: value,
        ads_amount: selectedPlan ? selectedPlan.amount : "",
      });

      return;
    }

    if (name === "payment_screenshot") {
      setRenewData({
        ...renewData,
        payment_screenshot: files[0],
      });

      return;
    }
  };

  const handleRenewSubmit = async () => {
    if (!renewData.show_ads_days) {
      alert("Please select ads plan");
      return;
    }

    // ✅ FREE PLAN VALIDATION
    const machine = machines.find(
      (m) => String(m.id) === String(renewMachineId),
    );

    if (renewData.ads_amount === "0" && machine?.machine_free_plan_used == 1) {
      alert("Free plan already used");
      return;
    }

    if (renewData.ads_amount !== "0" && !renewData.payment_screenshot) {
      alert("Please upload payment screenshot");
      return;
    }

    const formData = new FormData();

    formData.append("id", renewMachineId);
    formData.append("show_ads_days", renewData.show_ads_days);
    formData.append("ads_amount", renewData.ads_amount);

    if (renewData.payment_screenshot) {
      formData.append("payment_screenshot", renewData.payment_screenshot);
    }

    try {
      const res = await fetch(API.UPDATE_MACHINE, {
        method: "POST",
        body: formData,
      });

      const text = await res.text();

      console.log("Renew RAW:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (err) {
        alert("Invalid server response");
        return;
      }

      if (data.status) {
        alert("Ads renewed successfully");

        setRenewPopup(false);

        setRenewData({
          show_ads_days: "",
          ads_amount: "",
          payment_screenshot: null,
        });

        fetchMachines();
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    }
  };
  const isExpired = (item) => {
    // Pending machine should not show renew button
    if (item.status?.toLowerCase() === "pending") {
      return false;
    }

    // If no expiry date
    if (!item.ads_end_date) {
      return false;
    }

    const now = new Date().getTime();
    const expiry = new Date(item.ads_end_date.replace(" ", "T")).getTime();

    return expiry <= now;
  };
  return (
    <div className="workspace-container">
      <h2 className="machine-title">
        {form.id ? "Edit Machine" : "Add Machine"}
      </h2>

      {showForm && (
        <>
          <form onSubmit={handleSubmit} className="workspace-form">
            {/* Seller Section */}
            <div className="workspace-section">
              <label>Machine Details</label>
              <hr />
            </div>

            <div className="workspace-grid">
              <div className="row">
                <div className="col-md-6">
                  <div className="workspace-field-small">
                    <label>Seller Name</label>
                    <input
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      placeholder="Enter full name"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="workspace-field-small">
                    <label>Address</label>
                    <input
                      name="location"
                      value={form.location}
                      onChange={handleChange}
                      placeholder="Enter full address"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>Mobile Number</label>
                    <input
                      name="phone"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Enter phone number"
                      required
                    />

                    {errors.phone && (
                      <span className="error">{errors.phone}</span>
                    )}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>City</label>
                    <input
                      name="city"
                      value={form.city}
                      onChange={handleChange}
                      placeholder="Enter city"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>State</label>
                    <input
                      name="state"
                      value={form.state}
                      onChange={handleChange}
                      placeholder="Enter state"
                    />
                  </div>
                </div>
              </div>
              {/* </div>

       
            <div className="workspace-section">
              <label>Machine Details</label>
              <hr />
            </div>
            <div className="workspace-grid"> */}
              <div className="row">
                <div className="col-md-12">
                  {" "}
                  <div className="workspace-field">
                    <label>Machine Type</label>
                    <select
                      name="machine_name"
                      value={form.machine_name}
                      onChange={handleChange}
                      required
                      className={form.machine_name ? "active" : ""}
                    >
                      <option value="" disabled hidden>
                        Select Machine
                      </option>
                      <option value="FLAT EMBROIDERY MACHINE">
                        FLAT EMBROIDERY MACHINE
                      </option>
                      <option value="SEQUIN EMBROIDERY MACHINE">
                        SEQUIN EMBROIDERY MACHINE
                      </option>
                      <option value="CORDING EMBROIDERY MACHINE">
                        CORDING EMBROIDERY MACHINE
                      </option>
                      <option value="CHAIN EMBROIDERY MACHINE">
                        CHAIN EMBROIDERY MACHINE
                      </option>
                      <option value="BEADS EMBROIDERY MACHINE">
                        BEADS EMBROIDERY MACHINE
                      </option>

                      <option value="SEQUIN WITH CORDING EMBROIDERY MACHINE">
                        SEQUIN WITH CORDING EMBROIDERY MACHINE
                      </option>

                      <option value="SEQUIN WITH BEADS EMBROIDERY MACHINE">
                        SEQUIN WITH BEADS EMBROIDERY MACHINE
                      </option>
                      <option value="SEQUIN WITH BEADS AND CORDING EMBROIDERY MACHINE">
                        SEQUIN WITH BEADS AND CORDING EMBROIDERY MACHINE
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="workspace-field">
                    <label>Left Side Head Type</label>
                    <select
                      name="left_head_type"
                      value={form.left_head_type}
                      onChange={handleChange}
                      className={form.left_head_type ? "active" : ""}
                    >
                      <option value="" disabled hidden>
                        Select Left Side Head Type
                      </option>
                      <option value="SINGLE SEQUIN DEVICE">
                        SINGLE SEQUIN DEVICE
                      </option>
                      <option value="DUAL SEQUIN DEVICE">
                        DUAL SEQUIN DEVICE
                      </option>
                      <option value="THREE SEQUIN DEVICE">
                        THREE SEQUIN DEVICE
                      </option>
                      <option value="FOUR SEQUIN DEVICE">
                        FOUR SEQUIN DEVICE
                      </option>
                      <option value="EIGHT SEQUIN DEVICE">
                        EIGHT SEQUIN DEVICE
                      </option>
                      <option value="TWELVE SEQUIN DEVIC">
                        TWELVE SEQUIN DEVICE
                      </option>
                      <option value="CORDING DEVICE">CORDING DEVICE</option>
                      <option value="SINGLE BEAD DEVICE">
                        SINGLE BEAD DEVICE
                      </option>
                      <option value="DUAL BEAD DEVICE">DUAL BEAD DEVICE</option>
                      <option value="DUAL BEAD WITH DUAL SEQUIN DEVICE">
                        DUAL BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="THREE BEAD DEVICE">
                        THREE BEAD DEVICE
                      </option>
                      <option value="THREE BEAD WITH DUAL SEQUIN DEVICE">
                        THREE BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="FOUR BEAD DEVICE">FOUR BEAD DEVICE</option>
                      <option value="FOUR BEAD WITH DUAL SEQUIN DEVICE">
                        FOUR BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="NONE">NONE</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="workspace-field">
                    <label>Right Side Head Type</label>
                    <select
                      name="right_head_type"
                      value={form.right_head_type}
                      onChange={handleChange}
                      className={form.right_head_type ? "active" : ""}
                    >
                      <option value="" disabled hidden>
                        Select Left Side Head Type
                      </option>
                      <option value="SINGLE SEQUIN DEVICE">
                        SINGLE SEQUIN DEVICE
                      </option>
                      <option value="DUAL SEQUIN DEVICE">
                        DUAL SEQUIN DEVICE
                      </option>
                      <option value="THREE SEQUIN DEVICE">
                        THREE SEQUIN DEVICE
                      </option>
                      <option value="FOUR SEQUIN DEVICE">
                        FOUR SEQUIN DEVICE
                      </option>
                      <option value="EIGHT SEQUIN DEVICE">
                        EIGHT SEQUIN DEVICE
                      </option>
                      <option value="TWELVE SEQUIN DEVIC">
                        TWELVE SEQUIN DEVICE
                      </option>
                      <option value="CORDING DEVICE">CORDING DEVICE</option>
                      <option value="SINGLE BEAD DEVICE">
                        SINGLE BEAD DEVICE
                      </option>
                      <option value="DUAL BEAD DEVICE">DUAL BEAD DEVICE</option>
                      <option value="DUAL BEAD WITH DUAL SEQUIN DEVICE">
                        DUAL BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="THREE BEAD DEVICE">
                        THREE BEAD DEVICE
                      </option>
                      <option value="THREE BEAD WITH DUAL SEQUIN DEVICE">
                        THREE BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="FOUR BEAD DEVICE">FOUR BEAD DEVICE</option>
                      <option value="FOUR BEAD WITH DUAL SEQUIN DEVICE">
                        FOUR BEAD WITH DUAL SEQUIN DEVICE
                      </option>
                      <option value="NONE">NONE</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className="workspace-grid1">
                

         
                
              </div> */}
              <div className="row">
                <div className="col-md-4">
                  {" "}
                  <div className="workspace-field-small">
                    <label>Brand</label>
                    <input
                      name="brand"
                      value={form.brand}
                      onChange={handleChange}
                      placeholder="ZSK"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>Model</label>
                    <input
                      name="model"
                      value={form.model}
                      onChange={handleChange}
                      placeholder="Model number"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>No Of Heads</label>
                    <input
                      type="number"
                      name="NoOfHeads"
                      value={form.NoOfHeads}
                      onChange={handleChange}
                      placeholder="Example : 1"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>No Of Needles</label>
                    <input
                      type="number"
                      name="NoOfNeedls"
                      value={form.NoOfNeedls}
                      onChange={handleChange}
                      placeholder="Example : 12"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  {" "}
                  <div className="workspace-field-small">
                    <label>Max Sewing Speed (RPM)</label>
                    <input
                      type="number"
                      name="Maxsewingspeed"
                      value={form.Maxsewingspeed}
                      onChange={handleChange}
                      placeholder="RPM"
                      required
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>Computer Type</label>
                    <input
                      name="Comtype"
                      value={form.Comtype}
                      onChange={handleChange}
                      placeholder="Daho"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>Motor</label>
                    <input
                      name="motor"
                      value={form.motor}
                      onChange={handleChange}
                      placeholder="Servo / AC"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>USB Port</label>
                    <div className="machine-radio-group">
                      <label>
                        <input
                          type="radio"
                          name="usbport"
                          value="Yes"
                          checked={form.usbport === "Yes"}
                          onChange={handleChange}
                        />
                        Yes
                      </label>

                      <label>
                        <input
                          type="radio"
                          name="usbport"
                          value="No"
                          checked={form.usbport === "No"}
                          onChange={handleChange}
                        />
                        No
                      </label>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  {" "}
                  <div className="workspace-field-small">
                    <label>Price (Rs)</label>
                    <input
                      type="number"
                      name="price"
                      value={form.price}
                      onChange={handleChange}
                      placeholder="Enter price in Rupees"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  {" "}
                  <div className="workspace-field-small">
                    <label>Beam Body Size (MM)</label>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="number"
                        name="beamBodyWidth"
                        value={form.beamBodyWidth}
                        onChange={handleChange}
                        placeholder="Width"
                        className="designer-input"
                      />

                      <span style={{ fontWeight: "bold" }}>X</span>

                      <input
                        type="number"
                        name="beamBodyHeight"
                        value={form.beamBodyHeight}
                        onChange={handleChange}
                        placeholder="Height"
                        className="designer-input"
                      />
                    </div>
                    {/* <span style={{ marginLeft: "10px", fontWeight: "500" }}>
                  MM
                </span> */}
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="workspace-field-small">
                    <label>Machine Age</label>

                    <div style={{ display: "flex", gap: "10px" }}>
                      {/* Years */}
                      <input
                        type="number"
                        name="machine_year"
                        value={form.machine_year || ""}
                        onChange={handleChange}
                        placeholder="Years"
                      />

                      {/* Months */}
                      <input
                        type="number"
                        name="machine_month"
                        value={form.machine_month || ""}
                        onChange={handleChange}
                        placeholder="Months"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  {" "}
                  <div className="workspace-field-3">
                    <label>Description</label>
                    <textarea
                      name="description"
                      value={form.description}
                      onChange={handleChange}
                      placeholder="Enter machine description"
                    />
                  </div>
                </div>
              </div>
              {oldImages.length > 0 && (
                <div className="machine-preview-images">
                  {oldImages.map((img, index) => (
                    <div className="machine-image-box" key={index}>
                      <img
                        src={`${UPLOADS.MACHINE_IMAGE}${form.user_id}/${img}?t=${Date.now()}`}
                        alt="machine"
                      />
                      <button
                        type="button"
                        onClick={() => removeOldImage(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
              {/* Old Images */}

              {/* Upload Images */}
              <div className="workspace-field machine-full-width">
                <label>Upload Images (Max 6)</label>
                <input
                  type="file"
                  multiple
                  onChange={handleChange}
                  disabled={form.image.length + oldImages.length >= 6}
                />

                {errors.image && <span className="error">{errors.image}</span>}
              </div>
              <small>
                {form.image.length + oldImages.length}/6 Images Selected
              </small>
              {/* New Images Preview */}
              <div className="machine-preview-images">
                {form.image.map((img, index) => (
                  <div className="machine-image-box" key={index}>
                    <img src={URL.createObjectURL(img)} alt="preview" />
                    <button type="button" onClick={() => removeNewImage(index)}>
                      ×
                    </button>
                  </div>
                ))}
              </div>

              <div className="row">
                <div className="col-md-6">
                  {" "}
                  <div className="workspace-field-small">
                    <label>Show Ads For</label>
                    <select
                      name="show_ads_days"
                      value={form.show_ads_days}
                      onChange={handleChange}
                      className={form.show_ads_days ? "active" : ""}
                      required
                    >
                      <option value="" disabled hidden>
                        Select Days
                      </option>
                      {adsPlans.map((plan) => (
                        <option key={plan.id} value={plan.days}>
                          {plan.days} Days - ₹{plan.amount}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="workspace-field-small">
                    <label>Amount Pay</label>

                    <input
                      value={form.ads_amount}
                      readOnly
                      disabled={
                        form.status === "ACTIVE" &&
                        getTimeLeft(form.ads_end_date) !== "Expired"
                      }
                    />
                  </div>
                </div>
              </div>

              {form.show_ads_days && form.ads_amount !== "0" && (
                <div className="workspace-field machine-full-width">
                  <label>Scan & Pay</label>

                  <div className="payment-row">
                    <img src="/images/payment1.png" alt="QR" />

                    <p className="pay">OR</p>

                    <img src="/images/payment2.png" alt="QR" />
                    <a
                      href={`https://wa.me/919909614445?text=${encodeURIComponent(
                        "Hello, I have completed the payment. I am sending the screenshot for verification.",
                      )}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="whatsapp-btn"
                    >
                      <i className="bi bi-whatsapp"></i>
                      Send Screenshot on WhatsApp
                    </a>
                  </div>
                </div>
              )}
              {form.show_ads_days && form.ads_amount !== "0" && (
                <div className="workspace-field">
                  <label>Upload Payment Screenshot</label>

                  <input
                    type="file"
                    name="payment_screenshot"
                    onChange={handleChange}
                    disabled={
                      form.status === "ACTIVE" &&
                      getTimeLeft(form.ads_end_date) !== "Expired"
                    }
                  />
                </div>
              )}
              <div className="workspace-action-row">
                {form.id && (
                  <button
                    type="button"
                    className="btn-cancel-edit"
                    onClick={() => {
                      setForm({
                        id: "",
                        machine_name: "",
                        voltage: "",
                        NoOfHeads: "",
                        NoOfNeedls: "",
                        beamBody: "",
                        Maxsewingspeed: "",
                        usbport: "",
                        motor: "",
                        brand: "",
                        model: "",
                        condition: "",
                        price: "",
                        location: "",
                        city: "",
                        state: "",
                        name: "",
                        phone: "",
                        description: "",
                        image: [],
                        left_head_type: "",
                        right_head_type: "",
                        Comtype: "",
                        show_ads_days: "",
                        ads_amount: "",
                        payment_screenshot: null,
                        beamBodyWidth: "",
                        beamBodyHeight: "",
                        machine_old: "",
                        machine_year: "",
                        machine_month: "",
                      });

                      setOldImages([]);
                    }}
                  >
                    <i className="bi bi-x-circle me-2"></i>
                    Cancel Edit
                  </button>
                )}

                <button
                  type="submit"
                  className="btn-submit-workspace"
                  disabled={loading}
                >
                  {loading
                    ? "Processing..."
                    : form.id
                      ? "Update Machine"
                      : "Add Machine"}
                </button>
              </div>
            </div>
          </form>
        </>
      )}

      <div className="designs-grid">
        {machines.length > 0 ? (
          machines.map((item) => {
            const images = item.image
              ? item.image.split(",").filter((img) => img.trim() !== "")
              : [];

            return (
              <div className="design-card" key={item.id}>
                {/* IMAGE */}
                <div className="machine-img-container12">
                  <img
                    src={`${UPLOADS.MACHINE_IMAGE}${item.user_id}/${images[0]}?t=${Date.now()}`}
                    alt={item.machine_name}
                  />

                  <span className="heads-badge">{item.NoOfHeads} Heads</span>
                </div>

                {/* BODY */}
                <div className="machine-body">
                  <div className="machine-type">
                    <h4 className="machine-name">{item.machine_name}</h4>
                  </div>
                  {/* PRICE */}
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <div className="price-block">
                      <span className="currency-symbol">₹</span>
                      <span className="amount">
                        {Number(item.price).toLocaleString("en-IN")}
                      </span>
                    </div>

                    <button className="contact-btn">
                      <i className="bi bi-telephone-fill me-1"></i> Contact
                    </button>
                  </div>

                  {/* BRAND */}
                  <div className="spec-row mt-2">
                    <div className="spec-item">
                      <span className="spec-label">Brand:</span>
                      <span className="spec-value">{item.brand}</span>
                    </div>
                  </div>

                  <div className="location-info">
                    <i className="bi bi-geo-alt-fill"></i> {item.city},{" "}
                    {item.state}
                  </div>

                  {/* STATUS */}
                  {/* <div className="mt-2"> */}
                  {/* ⏳ EXPIRY TIMER */}
                  {/* {item.ads_end_date && (
                      <div className="expiry-timer">
                        {getTimeLeft(item.ads_end_date)}
                      </div>
                    )} */}
                  {/* ⏳ EXPIRY TIMER */}

                  {/* <span className={`status ${item.status?.toLowerCase()}`}>
                      {item.status}
                    </span>
                  </div> */}
                  {/* STATUS */}
                  <div className="mt-2">
                    {!isExpired(item) && (
                      <span className={`status ${item.status?.toLowerCase()}`}>
                        {item.status}
                      </span>
                    )}
                  </div>
                  <div className="mt-3"></div>
                  {!isExpired(item) ? (
                    item.ads_end_date && (
                      <div style={{ color: "green", fontWeight: "bold" }}>
                        Time Left: {getTimeLeft(item.ads_end_date, item.status)}
                      </div>
                    )
                  ) : (
                    <button
                      className="renew-btn"
                      onClick={() => {
                        setRenewMachineId(item.id);
                        setRenewData({
                          show_ads_days: "",
                          ads_amount: "",
                          payment_screenshot: null,
                        });
                        setRenewPopup(true);
                      }}
                    >
                      <i className="bi bi-arrow-clockwise me-2"></i>
                      Renew Ads
                    </button>
                  )}
                  <div className="machine-actions mt-3">
                    <button
                      className="action-btn view-action"
                      onClick={() => setViewData(item)}
                      title="View"
                    >
                      <i className="bi bi-eye-fill"></i>
                    </button>

                    <button
                      className="action-btn edit-action"
                      onClick={() => {
                        setShowForm(true);
                        setViewData(null);
                        setOldImages([]);

                        const parts = (item.beamBody || "")
                          .toLowerCase()
                          .split("x")
                          .map((v) => v.trim());

                        const w = parts[0] || "";
                        const h = parts[1] || "";

                        // ✅ MACHINE AGE SPLIT
                        let year = "";
                        let month = "";

                        if (item.machine_old) {
                          const ageParts = item.machine_old.split("/");

                          if (ageParts[0]) {
                            year = ageParts[0].replace("Years", "").trim();
                          }

                          if (ageParts[1]) {
                            month = ageParts[1].replace("Months", "").trim();
                          }
                        }

                        setForm({
                          id: item.id,
                          user_id: item.user_id,
                          machine_name: item.machine_name || "",
                          voltage: item.voltage || "",
                          NoOfHeads: item.NoOfHeads || "",
                          NoOfNeedls: item.NoOfNeedls || "",
                          beamBody: item.beamBody || "",
                          beamBodyWidth: w,
                          beamBodyHeight: h,
                          Maxsewingspeed: item.Maxsewingspeed || "",
                          usbport: item.usbport || "",
                          motor: item.motor || "",
                          brand: item.brand || "",
                          model: item.model || "",
                          condition: item.condition_status || "",
                          price: item.price || "",
                          location: item.location || "",
                          name: item.name || "",
                          city: item.city || "",
                          state: item.state || "",
                          phone: item.phone || "",
                          description: item.description || "",
                          image: [],
                          left_head_type: item.left_head_type || "",
                          right_head_type: item.right_head_type || "",
                          Comtype: item.Comtype || "",
                          show_ads_days: item.show_ads_days || "",
                          ads_amount: item.ads_amount || "",
                          machine_old: item.machine_old || "",

                          // ✅ IMPORTANT
                          machine_year: year,
                          machine_month: month,

                          payment_screenshot: null,
                        });

                        const imagesArray = (item.image || "")
                          .split(",")
                          .map((img) => img.trim())
                          .filter((img) => img.length > 0);

                        setOldImages(imagesArray);
                      }}
                      title="Edit"
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>

                    <button
                      className="action-btn delete-action"
                      onClick={() => deleteMachine(item.id)}
                      title="Delete"
                    >
                      <i className="bi bi-trash-fill"></i>
                    </button>
                  </div>
                  {/* {item.ads_end_date && (
                    <div className="machine-timer">
                      <div className="timer-icon">
                        <i className="bi bi-clock-history"></i>
                      </div>

                      <div className="timer-content">
                        <small>Ads Expiry In</small>
                        <span>{getTimeLeft(item.ads_end_date)}</span>
                      </div>
                    </div>
                  )} */}

                  {/* {getTimeLeft(item.ads_end_date, item.status) && (
                    <>
                      <div className="machine-timer">
                        <div className="timer-icon">
                          <i className="bi bi-clock-history"></i>
                        </div>

                        <div className="timer-content">
                          <small>Ads Expiry In</small>

                          <span
                            className={
                              getTimeLeft(item.ads_end_date) === "Expired"
                                ? "expired-text"
                                : ""
                            }
                          >
                            {getTimeLeft(item.ads_end_date)}
                          </span>
                        </div>
                      </div>

                      
                      {getTimeLeft(item.ads_end_date) === "Expired" && (
                        <button
                          className="reset-ads-btn"
                          onClick={() => {
                            setRenewMachineId(item.id);

                            setRenewData({
                              show_ads_days: "",
                              ads_amount: "",
                              payment_screenshot: null,
                            });

                            setRenewPopup(true);
                          }}
                        >
                          <i className="bi bi-arrow-repeat me-2"></i>
                          Renew Ads
                        </button>
                      )}
                    </>
                  )} */}
                </div>
              </div>
            );
          })
        ) : (
          <p>No machines listed yet.</p>
        )}
      </div>
      {viewData && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>⚙ Machine Details</h3>

              <button
                className="close-icon-btn"
                onClick={() => setViewData(null)}
              >
                ✕
              </button>
            </div>

            <div className="popup-grid">
              <div>
                <label>Request Send Date</label>
                <p>{viewData.created_at}</p>
              </div>
              <div>
                <label>Machine Type</label>
                <p>{viewData.machine_name}</p>
              </div>
              <div>
                <label>Left Side Head Type</label>
                <p>{viewData.left_head_type}</p>
              </div>
              <div>
                <label>Right Side Head Type</label>
                <p>{viewData.right_head_type}</p>
              </div>
              <div>
                <label>Brand</label>
                <p>{viewData.brand}</p>
              </div>
              <div>
                <label>Model</label>
                <p>{viewData.model}</p>
              </div>
              <div>
                <label> No Of Heads</label>
                <p>{viewData.NoOfHeads}</p>
              </div>
              <div>
                <label>No Of Needles</label>
                <p>{viewData.NoOfNeedls}</p>
              </div>
              <div>
                <label>Max Sewing Speed</label>
                <p>{viewData.Maxsewingspeed} RPM</p>
              </div>
              <div>
                <label>Beam Body Size(MM)</label>
                <p>{viewData.beamBody}</p>
              </div>
              <div>
                <label>Computer Type</label>
                <p>{viewData.Comtype}</p>
              </div>

              <div>
                <label>Motor</label>
                <p>{viewData.motor}</p>
              </div>
              <div>
                <label>Usb Port</label>
                <p>{viewData.usbport}</p>
              </div>
              <div>
                <label>Machine Age</label>
                <p>{viewData.machine_old}</p>
              </div>
              <div>
                <label>Price</label>
                <p>₹ {Number(viewData.price).toLocaleString("en-IN")}</p>
              </div>
              <div>
                <label>Status</label>
                <p>{viewData.status}</p>
              </div>
              <div>
                <label>Address</label>
                <p>{viewData.location}</p>
              </div>
              <div>
                <label>City & State</label>
                <p>
                  {viewData.city},{viewData.state}
                </p>
              </div>
              <div>
                <label>Seller</label>
                <p>
                  {viewData.name} ({viewData.phone})
                </p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{viewData.show_ads_days}</p>
              </div>

              <div>
                <label>Payed amount</label>
                <p>{viewData.ads_amount}</p>
              </div>
              <div>
                <label>Ads Start Date</label>
                <p>{viewData.ads_start_date}</p>
              </div>
              <div>
                <label>Ads End Date</label>
                <p>{viewData.ads_end_date}</p>
              </div>
              {viewData.payment_screenshot && (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>

                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/payment/${viewData.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/payment/${viewData.payment_screenshot}`}
                      alt="payment"
                      className="payment-thumb"
                    />
                  </div>
                </div>
              )}
            </div>
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}
            <div className="description-box">
              <label>Description</label>
              <p>{viewData.description}</p>
            </div>
            <div className="popup-images">
              {viewData.image &&
                viewData.image
                  .split(",")
                  .filter((img) => img && img.trim() !== "")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.MACHINE_IMAGE}${viewData.user_id}/${img}?t=${Date.now()}`}
                      alt="machine"
                    />
                  ))}
            </div>

            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {renewPopup && (
        <div className="popup-overlay">
          <div className="popup-box renew-popup">
            <div className="popup-header">
              <h3>Renew Ads</h3>

              <button
                className="close-icon-btn"
                onClick={() => setRenewPopup(false)}
              >
                ✕
              </button>
            </div>

            <div className="workspace-grid">
              {/* PLAN */}
              <div className="workspace-field">
                <label>Select Plan</label>

                <select
                  name="show_ads_days"
                  value={renewData.show_ads_days}
                  onChange={handleRenewChange}
                >
                  <option value="">Select Days</option>

                  {adsPlans.map((plan) => (
                    <option key={plan.id} value={plan.days}>
                      {plan.days} Days - ₹{plan.amount}
                    </option>
                  ))}
                </select>
              </div>

              {/* AMOUNT */}
              <div className="workspace-field">
                <label>Amount Pay</label>

                <input value={renewData.ads_amount} readOnly />
              </div>

              {/* QR */}
              {renewData.show_ads_days && renewData.ads_amount !== "0" && (
                <div className="workspace-field machine-full-width">
                  <label>Scan & Pay</label>

                  <img src="/images/payment1.png" width="200" alt="QR" />
                  <p className="pay">OR</p>
                  <img src="/images/payment2.png" width="200" alt="QR" />
                </div>
              )}

              {/* SCREENSHOT */}
              {renewData.show_ads_days && renewData.ads_amount !== "0" && (
                <div className="workspace-field machine-full-width">
                  <label>Upload Payment Screenshot</label>

                  <input
                    type="file"
                    name="payment_screenshot"
                    onChange={handleRenewChange}
                  />
                </div>
              )}

              {/* BUTTON */}
              <div className="machine-full-width">
                <button
                  type="button"
                  className="machine-submit-btn"
                  onClick={handleRenewSubmit}
                >
                  Submit Renewal
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* PAYMENT IMAGE FULL VIEW MODAL */}
      {/* {showPaymentModal && (
        <div className="popup-overlay">
          <div className="payment-popup-box">
            <button
              className="close-icon-btn payment-close-btn"
              onClick={() => setShowPaymentModal(false)}
            >
              ✕
            </button>

            <img
              src={paymentImage}
              alt="Payment Screenshot"
              className="payment-popup-image"
            />
          </div>
        </div>
      )} */}
    </div>
  );
}
